if (!window.dAgency) window.dAgency = {};
window.dAgency.initCountryLangDrawer = () => {
  const container = document.querySelector('.country-lang-drawer__container');
  if (!container) return;

  container
    .querySelectorAll(
      '.country-lang-drawer__backdrop, .country-lang-drawer__close',
    )
    .forEach((closer) =>
      closer.addEventListener('click', () =>
        container.classList.remove('open'),
      ),
    );

  document
    .querySelectorAll('[data-localization-opener]')
    .forEach((opener) =>
      opener.addEventListener('click', () => container.classList.add('open')),
    );

  const countryInput = container.querySelector('input[name="country_code"]');
  const langInput = container.querySelector('input[name="locale_code"]');

  if (!countryInput || !langInput) return;
  const countrySelect = container.querySelector(
    '.country-lang-drawer__select--country',
  );
  if (countrySelect)
    countrySelect.addEventListener('change', () => {
      countryInput.value = countrySelect.value;
      langInput.value = '';

      const langSelect = container.querySelector(
        `[data-country-code="${countrySelect.value}"]`,
      );
      if (!langSelect) return;
      container
        .querySelectorAll(
          `[data-country-code]:not([data-country-code="${countrySelect.value}"])`,
        )
        .forEach((wrongLang) => wrongLang.classList.add('hidden'));
      langSelect.classList.remove('hidden');
    });

  container
    .querySelectorAll('.country-lang-drawer__select--lang')
    .forEach((langSelect) =>
      langSelect.addEventListener(
        'change',
        () => (langInput.value = langSelect.value),
      ),
    );
};

if (document.readyState != 'loading') {
  window.dAgency.initCountryLangDrawer();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    window.dAgency.initCountryLangDrawer();
  });
}
